import type { FC } from "react";

import { REPOSITORY_INDEXING_MODE_OPTIONS } from "../../utils/repositoryIndexingModes";

export const IndexingRunModeGuide: FC = () => (
  <div className="rounded-none border border-slate-300 bg-slate-50 px-3 py-2 text-xs text-slate-700 dark:border-slate-700 dark:bg-arti-panel dark:text-slate-300">
    <div className="font-mono text-[10px] font-bold uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
      Mode Guide
    </div>
    <div className="mt-2 grid gap-2 md:grid-cols-3">
      {REPOSITORY_INDEXING_MODE_OPTIONS.map((option) => (
        <div key={option.value}>
          <div className="text-[11px] font-semibold text-slate-800 dark:text-slate-100">
            {option.label}
          </div>
          <div>{option.description}</div>
        </div>
      ))}
    </div>
  </div>
);
